// The reporter-facing name for a governed feedback record's status.
//
// A LEAF module (no React, no API, no imports) because commit 6 made My Feedback
// one page over two sources: the screenshot-package cards and the typed-intake
// rows both label the state of a governed record, and a tester discussing a
// record with a reviewer must hear the same word from both. Keeping it in
// MyFeedbackPage.jsx and importing it from the typed-intake section would have
// created an import cycle; duplicating it would have let the two drift.
//
// The vocabulary deliberately matches what the reviewer sees in the queue.
export function recordChip(record) {
  switch (record?.status) {
    case 'accepted':
      // 'green' — the feedback-chip palette has no 'sage' rule, which used to
      // render positive statuses in default gray.
      return { label: 'Accepted', tone: 'green' };
    case 'in_progress':
    case 'converted_to_action':
    case 'converted_to_issue':
      // Same vocabulary the reviewer sees in the queue — a tester and a
      // reviewer discussing one record must use the same words.
      return { label: 'In progress', tone: 'blue' };
    case 'resolved':
      return { label: 'Done', tone: 'green' };
    case 'needs_more_info':
      return { label: 'Needs more info', tone: 'amber' };
    case 'deferred':
      return { label: 'Deferred', tone: 'slate' };
    case 'rejected':
      return { label: 'Not planned', tone: 'slate' };
    case 'duplicate':
      return { label: 'Duplicate', tone: 'slate' };
    case 'triaged':
      return { label: 'In review', tone: 'blue' };
    default:
      return { label: 'Submitted', tone: 'blue' };
  }
}
